<template>
  <el-dialog :title="$t('labelManage.editTitle')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="editForm" :model="editLabelInfo" :rules="rules" label-width="120px">
      <el-form-item :label="$t('labelManage.labelName')" prop="labelName">
        <el-input v-model="editLabelInfo.labelName" :placeholder="$t('labelManage.labelNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('labelManage.domain')" prop="domain">
        <el-select v-model="editLabelInfo.domain" :placeholder="$t('labelManage.domainPlaceholder')" style="width:100%">
          <el-option v-for="item in editLabelInfo.domains" :key="item.statusCd" :label="item.name"
            :value="item.statusCd" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="editLabel">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { updateLabel } from '@/api/goods/labelApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditLabel',
  data() {
    return {
      dialogVisible: false,
      editLabelInfo: {
        labelId: '',
        labelName: '',
        domains: [],
        domain: '',
        labelType: 'C',
        shopId: ''
      },
      rules: {
        labelName: [
          { required: true, message: this.$t('labelManage.labelNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('labelManage.labelNameMaxLength'), trigger: 'blur' }
        ],
        domain: [
          { required: true, message: this.$t('labelManage.domainRequired'), trigger: 'change' }
        ],
        labelId: [
          { required: true, message: this.$t('labelManage.labelIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.editLabelInfo = { ...row }
      this.getDomains()
    },
    async getDomains() {
      try {
        const { data } = await getDict('s_label', 'domain')
        this.editLabelInfo.domains = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleClose() {
      this.$refs.editForm.resetFields()
      this.editLabelInfo = {
        labelId: '',
        labelName: '',
        domains: [],
        domain: '',
        labelType: 'C',
        shopId: ''
      }
    },
    editLabel() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          let shopId = getShopId()
          this.editLabelInfo.shopId = shopId
          try {
            await updateLabel(this.editLabelInfo)
            this.$message.success(this.$t('common.editSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            this.$message.error(error)
            console.error('修改标签失败:', error)
          }
        }
      })
    }
  }
}
</script>